import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import handleOpenWhatsApp from 'services/whatsappService';
import { cierre } from '../sortilegioContent';
import TnoMediaLabLogo, { MEDIA_LAB_TAGLINES } from 'components/TnoMediaLabLogo';

const Cierre = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <Box
        data-aos="fade-up"
        sx={{
          p: { xs: 4, md: 6 },
          borderRadius: 4,
          bgcolor: theme.palette.primary.dark,
          color: theme.palette.common.white,
          backgroundImage: `
            radial-gradient(circle at 88% 12%, ${alpha(theme.palette.secondary.light, 0.35)} 0%, transparent 36%),
            radial-gradient(circle at 8% 90%, ${alpha(theme.palette.common.white, 0.08)} 0%, transparent 32%)
          `,
        }}
      >
        <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 1.6, opacity: 0.8 }}>
          {cierre.overline}
        </Typography>
        <Typography
          variant="h3"
          component="h2"
          sx={{ fontWeight: 800, mt: 1.5, mb: 2, fontSize: { xs: '1.7rem', md: '2.2rem' }, lineHeight: 1.2 }}
        >
          {cierre.title}
        </Typography>
        <Typography sx={{ opacity: 0.92, lineHeight: 1.75, maxWidth: 720, mb: 4, fontSize: '1.05rem' }}>
          {cierre.subtitle}
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          endIcon={<ArrowForwardIcon />}
          onClick={() => handleOpenWhatsApp(null, cierre.whatsappMessage)}
          sx={{ px: 4, py: 1.6, fontWeight: 700 }}
        >
          {cierre.cta}
        </Button>
      </Box>

      <Box mt={5} display="flex" flexDirection="column" alignItems="center" textAlign="center">
        <TnoMediaLabLogo
          tagline={MEDIA_LAB_TAGLINES.agency}
          alt="TNO Media Lab"
          width={{ xs: 220, md: 280 }}
          height="auto"
          sx={{ mb: 1.5 }}
        />
        <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 600 }}>
          {cierre.footer}
        </Typography>
      </Box>
    </Box>
  );
};

export default Cierre;
